import { Component, Inject, TemplateRef, ViewChild } from "@angular/core";
import { FormControl } from "@angular/forms";
import {
    MAT_DIALOG_DATA,
    MatDialog,
    MatDialogRef,
} from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { AuthService } from "app/base-module/base-service/auth.service";
import { UsuarioService } from "app/base-module/base-service/usuario.service";
import { ClienteModel } from "app/clientes/models/cliente.model";
import { ClienteService } from "app/clientes/services/cliente.service";
import { EscritorioService } from "app/empreendimento/services/escritorio.service";
import { Escritorio } from "app/empresas/models/escritorio.model";
import { Usuario } from "app/usuarios/models/user.model";
import { map, Observable } from "rxjs";
import { BaseComponent } from "../../../base-module/base-component/base.component";

export interface DialogData {
    id: number;
    tipo: string;
}

@Component({
    selector: "app-filtro-lista-disponivel",
    templateUrl: "./filtro-lista-disponivel.component.html",
    styleUrls: ["./filtro-lista-disponivel.component.scss"],
    providers: [ClienteService, EscritorioService],
})
export class FiltroListaDisponivelComponent extends BaseComponent {
    cliente = new FormControl("");
    ativo = new FormControl("");
    assessor_id = new FormControl("");
    escritorio_id = new FormControl("");
    percentual = new FormControl("");
    tipo_percentual = new FormControl("MA");

    model: any = {
        escritorio_id: "",
        tipo_custodia: "",
        tipo_cliente: "",
    };

    loadingSpinner!: boolean;
    loadingSpinnerAtivos!: boolean;
    loadingSpinnerAssessor: boolean = false;
    loadingSpinnerEscritorio: boolean = false;

    filteredOptions!: Observable<ClienteModel[]>;
    filteredOptionsAtivo!: Observable<any[]>;
    listAssessor: Usuario[] = [];
    listEscritorios: Escritorio[] = [];
    listAtivos: any[] = [];
    usuario: any;
    titulo: any;

    @ViewChild("addButtonTmpl", { static: false })
    addButtonTmpl!: TemplateRef<any>;
    @ViewChild(FiltroListaDisponivelComponent, { static: false })
    table!: FiltroListaDisponivelComponent;

    constructor(
        public dialog: MatDialog,
        override snackBar: MatSnackBar,
        public dialogRef: MatDialogRef<FiltroListaDisponivelComponent>,
        private _clienteService: ClienteService,
        private usuarioService: UsuarioService,
        private _authService: AuthService,
        public escritorioService: EscritorioService,
        @Inject(MAT_DIALOG_DATA) public data: DialogData
    ) {
        super(dialog, snackBar);

        const strUser = this._authService.getUser();
        this.usuario = JSON.parse(strUser ? strUser : "{}");

        this.cliente.valueChanges.subscribe((query) => {
            if (typeof query === "string" || typeof query === "number") {
                this.loadingSpinner = true;
                this.params.search = query;
                this.filteredOptions = this._clienteService.search(this.params).pipe(map(response => response.data));
            }
        });

        this.getAllEscritorios();
        this.getAssessores();

        if (this.data.tipo == "incosistencia") {
            this.titulo = "Filtrar Clientes com Inconsistências";
        } else {
            this.titulo =
                "Filtrar Clientes que estão disponiveis para investir";
        }
    }

    displayFn(cliente: any): string {
        if (cliente) {
            return cliente.nome;
        }

        return "";
    }

    getCliente(cliente: any): void {
        this.loadingSpinner = false;
    }

    onNoClick(): void {
        this.dialogRef.close("cancel");
    }

    selectEscritorio(event: any) {
        this.escritorio_id.setValue(event.value);
        this.getAssessores(event.value);
    }

    filtrar(): void {
        this.dialogRef.close({
            cliente: this.cliente.value,
            escritorio_id: this.escritorio_id.value,
            assessor_id: this.assessor_id.value,
            percentual: this.percentual.value,
            tipo_percentual: this.tipo_percentual.value,
        });
    }

    getAssessores(escritorio_id = "") {
        this.loadingSpinnerAssessor = true;
        this.usuarioService
            .getLista({ escritorio_id: escritorio_id })
            .subscribe(
                (resquest) => {
                    this.listAssessor = resquest.data ?? [];
                },
                (error) => {
                    this.loadingSpinnerAssessor = false;
                },
                () => {
                    this.loadingSpinnerAssessor = false;
                    console.log("complete");
                }
            );
    }

    getAllEscritorios() {
        this.loadingSpinnerEscritorio = true;
        this.escritorioService.getAllList({ no_paginate: true }).subscribe(
            (list) => {
                this.listEscritorios = list.data ?? [];
            },
            (error) => {
                this.loadingSpinnerEscritorio = false;
            },
            () => {
                this.loadingSpinnerEscritorio = false;
                console.log("complete");
            }
        );
    }
}
